import { Platform, Share } from 'react-native';

/**
 * Hand a link to the platform. On web, copy the bare URL to the clipboard (no
 * Web Share API dialog). On native, open the OS share sheet with the bare URL.
 * Returns how the link was surfaced so callers can give the right confirmation
 * ("copied" vs. native sheet).
 */
export async function shareLink(url: string): Promise<'shared' | 'copied' | 'none'> {
  if (Platform.OS === 'web') {
    const nav = globalThis.navigator as
      | { clipboard?: { writeText: (t: string) => Promise<void> } }
      | undefined;
    if (nav?.clipboard) {
      await nav.clipboard.writeText(url);
      return 'copied';
    }
    return 'none';
  }

  await Share.share({ message: url });
  return 'shared';
}
